import type { Revision } from '../../types';
import { addUserEdits, mutations } from '../../utils';

/**
 * Mark a revision as edited by a user.
 */
export function markRevisionAsEdited(
    revision: mutations.MutableData<Revision>,
    userId: string | string[]
) {
    const edits = mutations.get(revision, 'edits');
    mutations.set(
        revision,
        'edits',
        addUserEdits(edits, Array.isArray(userId) ? userId : [userId])
    );
}
